import { menuItems, SPECIAL_EMAIL_ACCESS } from '../../components/SideBar';

// Sayfa Yetkileri'nin hesapları (eski sayfadaki fonksiyonlar, aynı davranış).
// Menü başlıkları Türkçe tutulur; ekranda yol üzerinden tMenu ile çevrilir,
// bu yüzden her kayıt kendi `path` / `groupPath` bilgisini taşır.

// The management tool itself must never be grantable through this UI.
export const SELF_PATH = '/sayfa-yetkileri';

// Güçlü şifre üret (CreateUserModal ile aynı mantık)
export const generateStrongPassword = (length = 12) => {
  const charset =
    'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+';
  let pw = '';
  for (let i = 0; i < length; ++i) {
    pw += charset.charAt(Math.floor(Math.random() * charset.length));
  }
  if (!/[A-Z]/.test(pw)) pw += 'A';
  if (!/[a-z]/.test(pw)) pw += 'a';
  if (!/[0-9]/.test(pw)) pw += '1';
  if (!/[!@#$%^&*()_+]/.test(pw)) pw += '!';
  return pw.slice(0, length);
};

// Build a flat, de-duplicated list of navigable pages grouped by their menu.
export const buildPages = () => {
  const pages = [];
  const seen = new Set();
  menuItems.forEach((group) => {
    const children =
      group.submenu && group.submenu.length > 0
        ? group.submenu.map((sub) => ({
            group: group.title,
            groupPath: group.path,
            title: sub.title,
            path: sub.path,
            requiredAuth: sub.requiredAuth || group.requiredAuth || []
          }))
        : [
            {
              group: group.title,
              groupPath: group.path,
              title: group.title,
              path: group.path,
              requiredAuth: group.requiredAuth || []
            }
          ];
    children.forEach((page) => {
      if (page.path === SELF_PATH) return;
      if (seen.has(page.path)) return;
      seen.add(page.path);
      pages.push(page);
    });
  });
  return pages;
};

// `authorization` may be stored as a single string (single-select dropdown in
// Çalışan Yönetimi) or, for some records, an array. Normalize to a role array.
export const getRoles = (emp) => {
  const a = emp && emp.authorization;
  if (Array.isArray(a)) return a.length > 0 ? a : ['employee'];
  if (typeof a === 'string' && a.trim()) return [a.trim()];
  return ['employee'];
};

// Yetkilendirme ("authorization") alanı "admin" olan çalışanları tespit et.
export const isAdmin = (emp) =>
  getRoles(emp).some((r) => String(r).trim().toLocaleLowerCase('tr-TR') === 'admin');

// Yetkilendirme ("authorization") alanı "Kısıtlı Admin" olan çalışanları tespit et.
export const isRestrictedAdmin = (emp) =>
  getRoles(emp).some((r) => String(r).trim().toLocaleLowerCase('tr-TR') === 'kısıtlı admin');

export const isRoleGranted = (page, roles) =>
  !page.requiredAuth || page.requiredAuth.length === 0
    ? true
    : page.requiredAuth.some((r) => roles.includes(r));

export const isSpecialGranted = (page, email) => {
  const sp = SPECIAL_EMAIL_ACCESS[(email || '').toLowerCase()];
  return sp ? sp.includes(page.path) : false;
};

// Aktiflik LoginPage ile aynı şekilde belirlenir: Active === 1 dışındaki her
// değer (0, undefined, '0') pasif kabul edilir.
export const isActiveEmployee = (emp) => Number(emp && emp.Active) === 1;

export const fullName = (emp) => `${emp.eName || ''} ${emp.eSurname || ''}`.trim() || '—';

// Effective access for a page, given an explicit DB grant list
export const pageState = (page, grants, email, roles) => {
  if (isRoleGranted(page, roles)) return 'role';
  if (isSpecialGranted(page, email)) return 'special';
  if (grants.includes(page.path)) return 'granted';
  return 'none';
};

// Rota yolunu ("/project-management") menüdeki okunabilir karşılığına çevirir
// ("Proje Menü · Proje Yönetimi"). Menüde olmayan yollar için yolun kendisi
// gösterilir, böylece yeni eklenen sayfalar da bir şey ifade eder.
const buildPathLabels = () => {
  const labels = {};
  menuItems.forEach((group) => {
    if (group.path) {
      labels[group.path] = { group: group.title, groupPath: group.path, title: group.title, path: group.path };
    }
    (group.submenu || []).forEach((sub) => {
      if (sub.path) labels[sub.path] = { group: group.title, groupPath: group.path, title: sub.title, path: sub.path };
    });
  });
  // Menüde yer almayan ama sık kullanılan sayfalar
  labels['/profile'] = { group: 'Profil', groupPath: '/profile', title: 'Profil', path: '/profile' };
  labels['/hall'] = { group: 'Hall', title: 'Hall · Sistem Seçimi', path: '/hall', special: 'hall' };
  labels['/'] = { group: 'Ana Sayfa', title: 'Ana Sayfa', path: '/', special: 'login' };
  return labels;
};

const PATH_LABELS = buildPathLabels();

export const describePath = (path) => {
  if (!path) return null;
  const known = PATH_LABELS[path];
  if (known) return known;
  // /project-management/123 gibi alt yollar için üst yolu dene
  const base = `/${String(path).split('/').filter(Boolean)[0] || ''}`;
  if (PATH_LABELS[base]) return PATH_LABELS[base];
  return { group: 'Diğer', title: path, path, special: 'other' };
};
